import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
const TARGET_QUENCH_FLOW = {
    id: 'target_material_quench_flow',
    type: 'target',
    name: 'Квенч',
    position: Position.Left,
    style: { top: 100, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_RAW_FLOW = {
    id: 'target_material_raw_flow',
    type: 'target',
    name: 'Сырьё',
    position: Position.Left,
    style: { top: 169, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_RAW_WITH_RECIRCULATE_FLOW = {
    id: 'target_material_raw_with_recirculate_flow',
    type: 'target',
    name: 'Сырьё с рециркулятом',
    position: Position.Left,
    style: { top: 169, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_GAS_WITH_QUENCH_FLOW = {
    id: 'source_material_gas_with_quench_flow',
    type: 'source',
    name: 'Газы коксования с квенчем',
    position: Position.Right,
    style: { top: 69, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_TOP_PRODUCT_FLOW = {
    id: 'source_material_top_product',
    type: 'source',
    name: 'Газы ($C_1, C_2, H_2S$ и прочее)',
    position: Position.Right,
    style: { top: 15, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_WATER_FLOW = {
    id: 'source_material_water',
    type: 'source',
    name: '$H_2O$',
    position: Position.Right,
    style: { top: 33, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_1_FLOW = {
    id: 'source_material_frac_1',
    type: 'source',
    name: 'СУГ ($C_3, C_4$)',
    position: Position.Right,
    style: { top: 51, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_2_FLOW = {
    id: 'source_material_frac_2',
    type: 'source',
    name: 'Нафта коксования',
    position: Position.Right,
    style: { top: 69, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_3_FLOW = {
    id: 'source_material_frac_3',
    type: 'source',
    name: 'Лёгкий газойль',
    position: Position.Right,
    style: { top: 87, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_4_FLOW = {
    id: 'source_material_frac_4',
    type: 'source',
    name: 'Тяжёлый газойль',
    position: Position.Right,
    style: { top: 105, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_LOGICAL = {
    id: 'target_logical_flow',
    type: 'target',
    name: 'Входные параметры',
    position: Position.Left,
    style: { top: 178, left: 8, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_LOGICAL = {
    id: 'source_logical_flow',
    type: 'source',
    name: 'Выходные параметры',
    position: Position.Right,
    style: { top: 178, right: 8, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
export const COKER_CONFIG = {
    type: ERFElement.Coker,
    icon: 'Coker_2d',
    templates: [
        {
            code: 'universal-template_mixer_reactorblock_heater',
            ports: [
                TARGET_RAW_WITH_RECIRCULATE_FLOW,
                SOURCE_GAS_WITH_QUENCH_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_mixers_reactorblock_heater_fractionator',
            ports: [
                TARGET_QUENCH_FLOW,
                TARGET_RAW_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_WATER_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_FRAC_3_FLOW,
                SOURCE_FRAC_4_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        }
    ]
};
//# sourceMappingURL=RFCokerNode.config.js.map